module.exports = __webpack_public_path__ + "img/professioneel-logo-kapsalon-extensions-hairdresser-allur-by-steffi-vermeersch-olsene-haar-3.f445f364.png";